import { defineMessages } from "react-intl";

const SECRET_QUESTION_ANSWER = "secret-question-answer";

const secretQuestionAnswerMessages = defineMessages({
  required: {
    id: `${SECRET_QUESTION_ANSWER}.required`,
    defaultMessage: "Please provide an answer",
    description:
      "Input error displayed if a secret question answer is not entered"
  }
});

export default secretQuestionAnswerMessages;
